import { render, staticRenderFns } from "./sotialNetworks.vue?vue&type=template&id=91789328&scoped=true&"
import script from "./sotialNetworks.vue?vue&type=script&lang=js&"
export * from "./sotialNetworks.vue?vue&type=script&lang=js&"
import style0 from "./sotialNetworks.vue?vue&type=style&index=0&id=91789328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91789328",
  null
  
)

export default component.exports